// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "main." + "b50a1964cc7d85f58aa6" + ".css";
};